
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { PermissionItemProps } from ".";
import { loading, find } from "store/permission";

interface ApiPermissionFindByIdInputProps {
    id: number;
}

type ApiPermissionFindOutputProps = OutputBaseProps<{ item: PermissionItemProps; }, ApiPermissionFindByIdInputProps>

export const apiPermissionFindById = async (data: ApiPermissionFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiPermissionFindOutputProps>(`/api/permission/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};